import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import {useDownloadPanelData} from '@Components/download-panel/download-panel.context';
import {FileTypeOptions} from '@Components/download-panel/components/file-type-option/file-type-option.types';
import {DownloadImageDesignSizeOption} from '@Components/download-panel/components/download-image-design-size-option/download-image-design-size-option';
import {DownloadGifDesignSizeOption} from '@Components/download-panel/components/download-gif-design-size-option/download-gif-design-size-option';
import {DownloadVideoDesignSizeOption} from '@Components/download-panel/components/download-video-design-size-option/download-video-design-size-option';
import {noop} from '@Utils/general.util';

interface DownloadDesignSizeOptionWrapperProps {
  onSlideCallback?(): void;
  onSlideEndedCallback?(): void;
}

export function DownloadDesignSizeOptionWrapper({onSlideCallback = noop, onSlideEndedCallback = noop}: DownloadDesignSizeOptionWrapperProps): ReactElement | null {
  const {fileType} = useDownloadPanelData();

  if (fileType === FileTypeOptions.WEBP || fileType === FileTypeOptions.WEBM || fileType === FileTypeOptions.PDF) {
    return null;
  }

  const getDropdownFromType = (): ReactElement => {
    if (fileType === FileTypeOptions.PNG || fileType === FileTypeOptions.JPG) {
      return <DownloadImageDesignSizeOption onSlideCallback={onSlideCallback} onSlideEndedCallback={onSlideEndedCallback} />;
    }

    if (fileType === FileTypeOptions.GIF) {
      return <DownloadGifDesignSizeOption onSlideCallback={onSlideCallback} onSlideEndedCallback={onSlideEndedCallback} />;
    }

    return <DownloadVideoDesignSizeOption />;
  };

  const getDropdownOption = (): ReactElement => {
    return (
      <div className="_full-width flex-h-row justify-content-between flex-items-center">
        <Text bold val={window.i18next.t('pmwjs_size')} size={TextSize.XSMALL} />
        {getDropdownFromType()}
      </div>
    );
  };
  return getDropdownOption();
}
